import { QuestionTextProps } from './types';

export function QuestionText({ question, helperText, error }: QuestionTextProps) {
  return (
    <div className="space-y-2 text-center mb-8">
      <h3 className="text-4xl font-semibold max-w-[500px] mx-auto mb-6 text-balance">{question}</h3>
      {helperText && (
        <p className="text-sm sm:text-base text-muted-foreground max-w-[550px] mx-auto text-balance">{helperText}</p>
      )}
      {error && (
        <p className="text-destructive text-sm">{error}</p>
      )}
    </div>
  );
} 